// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorBoundary-container-2XU1z","content":"ErrorBoundary-content-QyBKv"};